<template>
    <div class="bg-a-egg-f5ebdc min-h-screen">
        <UltimateTopBarBack></UltimateTopBarBack>
        <ProfileBar></ProfileBar>
        <ShoppingBag></ShoppingBag>
        <Notification></Notification>
        <Subscription></Subscription>
        <div class="content-page container mx-auto" :class="[customClass, cookieClass]">
            <!-- <div v-if="isShowDelivery" class="block lg:hidden">
                <DeliveryBox></DeliveryBox>
            </div> -->
            <slot></slot>
        </div>
        <MainFooter :hideMobile="hideMobile"></MainFooter>
    </div>
</template>
<script>
import { provide, ref } from 'vue'
import UltimateTopBarBack from '../TopBar/UltimateTopBar/UltimateTopBarBack.vue'
// import DeliveryBox from './HomeLayout/DeliveryBox.vue'
import ShoppingBag from '../SideMenu/ShoppingBag.vue'
import MainFooter from '../Footer/MainFooter.vue'
import ProfileBar from '../SideMenu/ProfileBar.vue'
import Notification from '../SideMenu/Notification.vue'
import Subscription from '../SideMenu/Subscription.vue';
import CookieMixin from '../../../mixin/CookieMixin.js';

export default {
    mixins: [CookieMixin],
    props: {
        // isShowDelivery:     { type: Boolean, default: false },
        customClass: { type: String, default: null },
        showCart: {
            type: Boolean,
            default: false
        },
        hideMobile: {
            type: Boolean,
            default: true,
        }
    },
    components: {
        UltimateTopBarBack,
        // DeliveryBox,
        MainFooter,
        ShoppingBag,
        ProfileBar,
        Notification,
        Subscription,
    },
    setup: function (props) {
        const config = ref({
            topBar: {
                right: {
                    showCart: props.showCart
                }
            }
        })
        provide("LayoutConfig", config)
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";

.content-page {
    padding-top: $topbar-height;
    min-height: 100vh;
    @media (max-width: 575px) {
        min-height: calc(100vh - 169px);
    }
    &.accept-cookie {
        padding-top: 140px;

        @media (min-width: 1024px) {
            padding-top: 108px;
        }
    }
}
</style>
